import { useQuery } from "@tanstack/react-query";
import { APIClient } from "../constants";
import { IOrdItem } from "../types";

export const useTokenById = (inscriptionId: string) => {
  return useQuery(
    ["token", inscriptionId],
    async () => {
      try {
        const { data } = await APIClient.get<IOrdItem>(
          `/tokens/${inscriptionId}`
        );
        return data;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    {
      enabled: !!inscriptionId,
    }
  );
};
